<!-- Verify identity page heading -->
<section class="wrapper-container">
  <gds-heading
    [data]="{
      heading:
        pageLabels?.['com.udx.account.onetimepasscode.stepheader'] ||
        'Verify your identity',
    }"
    tagtype="h1"
    classes="heading-3"
  >
  </gds-heading>
  <gds-spacer classes="spacer-70"></gds-spacer>
  <div class="text-content">
    <gds-body
      [data]="{
        description:
          (pageLabels?.['com.udx.account.onetimepasscode.input_instruction'] ||
            'Enter the 6-digit verification code we sent to') +
          ' ' +
          maskedEmailAddress +
          '.',
      }"
      class="B1-W2"
    ></gds-body
    >&nbsp;<gds-buttons
      [data]="{
        type: 'tertiary',
        href: identityVerificationUrl,
        label:
          pageLabels?.['com.udx.account.onetimepasscode.resend_link'] ||
          'Resend code',
        target: '',
        disabled: isResending(),
      }"
      (buttonClicked)="onResendCode()"
      (keydown)="onSpacebarPress($event)"
    >
    </gds-buttons>
  </div>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <!-- srCodeComplete/srCodePasted use a single space, not '' - gds-otp-input's
       [data] reader does `value || default`, so '' is ignored (UPT-224513). -->
  <gds-otp-input
    #otpInput
    [data]="{
      required: true,
      describedby: 'otp-verification-code-error',
      autocomplete: 'one-time-code',
      srCodeComplete: ' ',
      srCodePasted: ' ',
    }"
    [errors]="otpInlineError || undefined"
    (valueChange)="onValueChange($event.detail)"
  >
  </gds-otp-input>
  <div class="sr-only" aria-live="polite" aria-atomic="true" role="status">
    {{ otpAutofillAnnouncement }}
  </div>

  <gds-spacer classes="spacer-50"></gds-spacer>
  <div class="timerWidth">
    @if (showTimer()) {
      <gds-countdown-timer
        [data]="{
          heading:
            pageLabels?.[
              'com.udx.account.onetimepasscode.content_callout_mini_description'
            ] || 'Code will expire in:',
          announceUpdates: true,
          announceIntervals: time_interval,
          expiredMessage:
            pageLabels?.['com.udx.account.onetimepasscode.error_expired'] ||
            'Your verification code has expired. Please request a new code.',
        }"
        [duration]="codetimer"
        [autoStart]="true"
        [format]="'hh:mm:ss'"
      >
      </gds-countdown-timer>
    }
  </div>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-accordion
    [data]="{
      subheading:
        pageLabels?.['com.udx.account.onetimepasscode.help_toggle_label'] ||
        'Need help verifying your identity?',
      headerOption: 'secondary',
      option: 'option1',
      disabled: false,
    }"
  >
    <div style="padding: 0 16px">
      <gds-body
        class="B1-W2"
        [innerHTML]="
          pageLabels?.['com.udx.account.onetimepasscode.help_description'] ||
          'If you did not receive the code, please check your spam folder or request a new code. For further assistance, contact Guest Services.'
        "
      ></gds-body>
      <gds-spacer classes="spacer-20"></gds-spacer>

      <gds-body
        class="B1-W2"
        [innerHTML]="
          pageLabels?.[
            'com.udx.account.onetimepasscode.guest_services_support'
          ] || 'Guest Services Support'
        "
      ></gds-body>
      <br />
      <gds-body
        class="B1-W2 heading-hover-underline"
        [innerHTML]="
          pageLabels?.['com.udx.account.onetimepasscode.guest_services_call'] ||
          'Call <a href=&quot;tel:+18007756750&quot;>+1-800-775-6750</a>'
        "
        appLinkSpacebarActivation
      ></gds-body>
    </div>
  </gds-accordion>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <!-- Verify identity CTA buttons -->
  <div class="action-bar">
    <gds-spacer classes="vertical-spacer-50"></gds-spacer>
    <gds-buttons
      [data]="{
        type: 'primary',
        href: targetUrl,
        label:
          pageLabels?.['com.udx.account.onetimepasscode.button_submit'] ||
          'Submit',
        disabled: submitCTADisabled(),
        target: '',
      }"
      (buttonClicked)="verifyCode()"
    >
    </gds-buttons>
  </div>

  @if (resendCooldownSnackBarVisible && resendCooldownSnackBarData) {
    <div class="resend-cooldown-snack-bar">
      <gds-snack-bar
        [data]="resendCooldownSnackBarData"
        (snackBarClosed)="hideResendCooldownSnackBar()"
      ></gds-snack-bar>
    </div>
  }
</section>
